import * as React from 'react';
import { ButtonCallToAction } from 'ui';
import { CodetableTranslation } from 'app/area/indicator-factors/constants';
import { saveButtonConfig } from 'app/area/indicator-factors/item/sticky-header/save-button-config';
import { CodeActionType, ReadOnlyConfiguration, ReadOnlyType } from 'app/area/indicator-factors/item/types';

interface SaveButtonProps {
  codetableId: number;
  actionType: CodeActionType;
  readOnlyConfig: ReadOnlyConfiguration;
  shouldPrompt: boolean;
  translation: CodetableTranslation;
  save: () => void;
}

export const SaveButton = (saveButtonProps: SaveButtonProps) => {
  const { codetableId, actionType, readOnlyConfig, shouldPrompt, translation, save } = saveButtonProps;
  const config = saveButtonConfig({ actionType, shouldPrompt, translation });

  return !readOnlyConfig[ReadOnlyType.save]
    && <ButtonCallToAction
      id={`codetable-sticky-header-save-button-${codetableId}`}
      onClick={save}
      disabled={config?.disabled}>
      {config?.text}
    </ButtonCallToAction>;
};
